import Api from './base.api';
import md5 from 'md5';

interface IStudentsApi {
  fetchList: (type: string) => Promise<any>;
  add: (params: { fullName: string; project: string }) => Promise<any>;
  edit: (params: { teacherName: string; id: number | string }) => Promise<any>;
  delete: (id: string) => Promise<any>;
}

class StudentsApi extends Api implements IStudentsApi {
  fetchList = (projectId: string) =>
    this.request(`students?projectId=${projectId}`);

  add = (params: { fullName: string; project: string }) =>
    this.request('students/add', {
      method: 'post',
      body: JSON.stringify(params),
    });

  addByQr = async (params: any) => {
    const currentDate = new Date();
    const dayString = currentDate.getUTCDate().toString();
    const publicToken = `public_token_${dayString}`;
    const hashedToken = md5(publicToken);

    return this.request('students/add_by_qrcode', {
      method: 'post',
      body: JSON.stringify(params),
    }, hashedToken);
  };

  edit = (params: any) =>
    this.request(`students/${params.id}/edit`, {
      method: 'post',
      body: JSON.stringify(params),
    });

  delete = (id: string) =>
    this.request(`students/${id}/remove`, {
      method: 'delete',
    });
}

export default new StudentsApi();
